import { useEffect } from 'react';
import { CONSENT_CHANGE_EVENT } from '@/lib/consent';
import { loadGoogleAdsTag, trackPhoneConversion } from '@/lib/googleAds';

export default function GoogleAdsTag() {
  useEffect(() => {
    loadGoogleAdsTag();
    const onConsentChange = () => loadGoogleAdsTag();
    const onClick = (e: MouseEvent) => {
      const link = (e.target as Element | null)?.closest?.('a[href^="tel:"]');
      if (link) trackPhoneConversion();
    };
    window.addEventListener(CONSENT_CHANGE_EVENT, onConsentChange);
    document.addEventListener('click', onClick, true);
    return () => {
      window.removeEventListener(CONSENT_CHANGE_EVENT, onConsentChange);
      document.removeEventListener('click', onClick, true);
    };
  }, []);

  return null;
}
